/**
 * Canonical nav definition for the admin shell. Rendered by AdminLayout
 * (sidebar) and reused by AdminLayout.test.tsx. Every plan must update this
 * list if it adds/removes an item — it is the single source of truth.
 *
 * Order revised by owner decision 2026-06-11 (supersedes the original ADM-01
 * order): Tickets first, then Companies, then Users. Agreements moved off the
 * menu — they are managed inside the company profile (CompanyDetailPage);
 * the /admin/agreements route remains for deep links.
 */
export interface AdminTab {
  readonly key: string;
  readonly label: string;
  readonly to: string;
  /** Sub-paths (prefix match) that should also mark this tab active */
  readonly match?: readonly string[];
}

export const ADMIN_TABS: readonly AdminTab[] = [
  { key: 'tickets', label: 'Tickets', to: '/admin/tickets', match: ['/admin/tickets'] },
  { key: 'companies', label: 'Companies', to: '/admin/companies' },
  { key: 'users', label: 'Users', to: '/admin/users' },
  { key: 'knowledgebase', label: 'Knowledgebase', to: '/admin/knowledgebase' },
  { key: 'workflows', label: 'Workflows', to: '/admin/workflows' },
  {
    key: 'settings',
    label: 'Settings',
    to: '/admin/settings/integrations',
    match: ['/admin/settings'],
  },
  { key: 'reports', label: 'Reports', to: '/admin/reports' },
  { key: 'impersonation', label: 'Impersonation', to: '/admin/impersonation' },
] as const;
